import { useNavigate } from "react-router-dom";
import { BalanceBallGame } from "./BalanceBallGame";
import { stopAllAudio } from "../../../utils/audio";

export function BalanceBallRoute() {
  const navigate = useNavigate();

  const handleBack = () => {
    stopAllAudio();
    navigate("/game-selection");
  };

  return <BalanceBallGame onBack={handleBack} />;
}
